/**
 * Tough-Bar Builder - Response Adapter
 * Normalizes and validates step payloads returned by the builder API.
 */
window.ToughBarBuilder = window.ToughBarBuilder || {};

(() => {
  const STEP_NAME_ALIASES = {
    vehicle_selection: 'vehicle',
    device_selection: 'device',
    accessory: 'accessories',
    accessory_selection: 'accessories',
    accessories_selection: 'accessories'
  };

  const isPlainObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

  const normalizeStepName = rawStepName => {
    const normalized = String(rawStepName || '').trim().toLowerCase();
    if (!normalized) return '';
    return STEP_NAME_ALIASES[normalized] || normalized;
  };

  class ToughBarApiContractError extends Error {
    constructor(message, details = {}) {
      super(message);
      this.name = 'ToughBarApiContractError';
      this.details = details;
    }
  }

  const adaptBuilderResponse = rawResponse => {
    if (!isPlainObject(rawResponse)) {
      throw new ToughBarApiContractError('Response body is not a JSON object.', {
        response_type: typeof rawResponse
      });
    }

    const step = Number(rawResponse.step);
    const stepName = normalizeStepName(rawResponse.step_name ?? rawResponse.stepName);
    const missing = [];

    if (!Number.isFinite(step) || step < 1) missing.push('step');
    if (!stepName) missing.push('step_name');

    const requiresSection = Number.isFinite(step) && step >= 1 && step <= 3;
    const requiresKit = Number.isFinite(step) && step >= 2;
    const requiresKits = Number.isFinite(step) && step >= 4;

    if (requiresSection && !isPlainObject(rawResponse.section)) missing.push('section');
    if (requiresKit && !isPlainObject(rawResponse.kit)) missing.push('kit');
    if (requiresKits && !Array.isArray(rawResponse.kits)) missing.push('kits');

    if (missing.length > 0) {
      throw new ToughBarApiContractError(`Missing or invalid required fields: ${missing.join(', ')}`, {
        missing,
        keys: Object.keys(rawResponse)
      });
    }

    return {
      ...rawResponse,
      step,
      step_name: stepName,
      section: isPlainObject(rawResponse.section) ? rawResponse.section : {},
      kit: isPlainObject(rawResponse.kit) ? rawResponse.kit : {},
      kits: Array.isArray(rawResponse.kits) ? rawResponse.kits : []
    };
  };

  window.ToughBarBuilder.responseAdapter = {
    adaptBuilderResponse,
    ToughBarApiContractError
  };
})();
